import { TColumnsResolver } from '../../../../common/types/TColumnsResolver';

export const RxRulesColumnResolver: TColumnsResolver = (
  col: any,
  row: any,
): string | JSX.Element | undefined => {
  let cellValue;
  if (col.name === 'ruleId') {
    cellValue = `${row.ruleId ? row.ruleId : '-'}`;
  } else if (col.name === 'name') {
    cellValue = `${row.name ? row.name : '-'}`;
  } else if (col.name === 'modifier') {
    cellValue = `${row.modifier ? row.modifier : '-'}`;
  }
  return cellValue;
};
